(function () {
	const initCollapsibleContent = () => {
		document.querySelectorAll('.collapsible-content__toggle').forEach(toggle => {
			const newToggle = toggle.cloneNode(true);
			toggle.parentNode.replaceChild(newToggle, toggle);
			newToggle.addEventListener('click', function () {
				const parent = this.closest('.collapsible-content__item');
				const items = this.closest('.collapsible-content__items');
				const isActive = parent.classList.contains('active');

				if (items) {
					items.querySelectorAll('.collapsible-content__item.active').forEach(el => {
						el.classList.remove('active');
						const ans = el.querySelector('.collapsible-content__answer');
						if (ans) ans.style.display = 'none';
					});
				}

				if (!isActive) {
					parent.classList.add('active');
					const answer = this.nextElementSibling;
					if (answer) answer.style.display = 'block';
				}
			});
		});
	};

	document.addEventListener('shopify:section:load', function () {
		initCollapsibleContent();
	});

	initCollapsibleContent();
})();
